var _module_exports = "<div class=\"-formcontainer\"> <ui-view></ui-view> </div> ";;
var path = '/app/components/data-entry/data-entry-frame.component.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;